"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSendAsIsLoading = exports.getSendAsList = exports.getSendAsState = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _reselect = require("reselect");

var _root = require("../root.selector");

var getSendAsState = R.compose(R.prop('sendAs'), _root.getCreateGiftState);
exports.getSendAsState = getSendAsState;
var getSendAsList = (0, _reselect.createSelector)(getSendAsState, R.prop('users'));
exports.getSendAsList = getSendAsList;
var getSendAsIsLoading = R.compose(R.prop('isLoading'), getSendAsState);
exports.getSendAsIsLoading = getSendAsIsLoading;